import $ from 'jquery';
window.jQuery = $;



// jQuery Cookies
!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}return function n(o){function t(n,r,i){var c;if("undefined"!=typeof document){if(arguments.length>1){if("number"==typeof(i=e({path:"/"},t.defaults,i)).expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}i.expires=i.expires?i.expires.toUTCString():"";try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(e){}r=o.write?o.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=(n=(n=encodeURIComponent(String(n))).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent)).replace(/[\(\)]/g,escape);var s="";for(var f in i)i[f]&&(s+="; "+f,!0!==i[f]&&(s+="="+i[f]));return document.cookie=n+"="+r+s}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],d=/(%[0-9A-Z]{2})+/g,u=0;u<p.length;u++){var l=p[u].split("="),C=l.slice(1).join("=");this.json||'"'!==C.charAt(0)||(C=C.slice(1,-1));try{var g=l[0].replace(d,decodeURIComponent);if(C=o.read?o.read(C,g):o(C,g)||C.replace(d,decodeURIComponent),this.json)try{C=JSON.parse(C)}catch(e){}if(n===g){c=C;break}n||(c[g]=C)}catch(e){}}return c}}return t.set=t,t.get=function(e){return t.call(t,e)},t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}(function(){})});
// Slick Slider
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});



jQuery(document).ready($ => {


    const equalizeSite = () => {
        if (!accessibleFont) {
            // Found an issue with this script when a browser is zooming in/out so we disable it on zoom.
            //		const zoom = detectZoom.zoom();
            //		if(zoom != 1) return;

            // Break Points: These are what you have setup in the _settings.scss
            // The actual points where it converts from mobile to tablet and tablet to desktop.
            // Sometimes there is not a tablet design in this case simply set it to the same as the desktop.
            const $bptablet = 768;
            const $bpdesktop = 768;

            // Designed Sizes: These sizes are referencing what you are using to design the site e.g. PSD, AI etc.
            // This is what you have your media queries set to. Remember you only need 1 set of styles for each device this
            // script will handle the rest.
            const $mobile = 390;
            const $tablet = 768;
            const $desktop = 1520;

            // Initial Font Size: This is based on what the common copy font size is for each design.
            const $fsmobile = 16;
            const $fstablet = 16;
            const $fsdesktop = 16;

            const $ww = window.innerWidth;

            let $fontsize = 16;

            if ($ww < $bptablet) {
                // mobile
                $fontsize = $fsmobile * ($ww / $mobile);
            } else if ($ww < $bpdesktop) {
                // tablet
                $fontsize = $fstablet * ($ww / $tablet);
            } else if ($ww <= 1560) {
                // desktop
                $fontsize = $fsdesktop * ($ww / $desktop);
            } else {
                $fontsize = 16;
            }

            const fontsize = Cookies.get('fontsize');

            if (typeof fontsize !== 'undefined') {
                $fontsize = parseInt($fontsize) + parseInt(fontsize);
            }

            $('html').css('font-size', $fontsize);

            defaultSize = $fontsize;
        }
        safeRefresh();
    };

    let defaultSize = 16;
    let accessibleFont = false;


    $(document).on('click', '.smaller-font', e => {
        e.preventDefault();

        let fontsize = Cookies.get('fontsize');

        if (typeof fontsize === 'undefined') {
            fontsize = 0;
        }

        fontsize--;

        Cookies.set('fontsize', fontsize);
        equalizeSite();
    });

    $(document).on('click', '.larger-font', e => {
        e.preventDefault();

        let fontsize = Cookies.get('fontsize');

        if (typeof fontsize === 'undefined') {
            fontsize = 0;
        }

        fontsize++;

        Cookies.set('fontsize', fontsize);
        equalizeSite();
    });

    $(document).on('click', '.reset-font', e => {
        e.preventDefault();

        Cookies.set('fontsize', 0);
        equalizeSite();
    });

    $(document).on('click', '.high-contrast-btn', e => {
        e.preventDefault();
        $('body').removeClass('low-contrast');
        $('body').addClass('high-contrast');

        pinnedTriggers.forEach(trigger => trigger.kill());
    });

    $(document).on('click', '.low-contrast-btn', e => {
        e.preventDefault();
        $('body').removeClass('high-contrast');
        $('body').addClass('low-contrast');
        Cookies.set('contrast', 'low');

        pinnedTriggers.forEach(trigger => trigger.kill());
    });

    $(document).on('click', '.reset-contrast-btn', e => {
        e.preventDefault();
        $('body').removeClass('low-contrast');
        $('body').removeClass('high-contrast');
        Cookies.set('contrast', 0);

        createPanels();
    });


    const adminBarSpace = () => {
        const headerHeight = $('header').height();
        if (window.innerWidth > 768) {
            $('main').css('padding-top', `${headerHeight}px`);
        }
        if ($('body.admin-bar').length > 0) {
            const height = $('#wpadminbar').height();
            $('header').css('top', `${height}px`);
            $('.header__menu-button').css('top', `${height+50}px`);
            $('.header__menu').css('top', `${height+33}px`);
        } else {
            $('header').css('top', '0');
            $('.header__menu-button').css('top', '50px');
            $('.header__menu').css('top', '33px');
        }
    };

    adminBarSpace();
    equalizeSite();

    $(window).resize(() => {
        equalizeSite();
        adminBarSpace();
        checkExpandableBlocks();
    });

    $(document).on('click', '.accessibility-link', function(e) {
        e.preventDefault();
        $('.header__accessibility .dropdown').toggleClass('open');
    });

    $(document).on('click', '.menu__toggle', e => {
        e.preventDefault();
        $('body').toggleClass('menu-expanded');
    });

    $(window).on('scroll', handleHeaderOnScroll);
    handleHeaderOnScroll();
    function handleHeaderOnScroll() {
        if (window.scrollY > 180) {
            $('header').addClass('scrolled');
        } else {
            $('header').removeClass('scrolled');
        }
    }

    $('.media-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        fade: true,
        asNavFor: '.media-slider-nav',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    variableWidth: false,
                }
            }
        ]
    });
    $('.media-slider-nav').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.media-slider-for',
        dots: false,
        focusOnSelect: true,
        variableWidth: true,
    });


    $('.content-slider__slides').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    arrows: false,
                    variableWidth: false,
                }
            }
        ]
    });

    $('.featured-slider__slides').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    variableWidth: false
                }
            }
        ]
    });

    // $('.partners-slider').slick({
    //     slidesToShow: 5,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     dots: false,
    //     infinite: true,
    //     variableWidth: true,
    //     autoplay: true,
    //     autoplaySpeed: 0,
    //     speed: 4000, 
    //     cssEase: 'linear',
    // });


    const prevent_ways_slider_settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        mobileFirst: true, // Important for this approach
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 769,
                settings: "unslick"
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };



    const prevent_ways_slider = $('.prevent-ways').slick(prevent_ways_slider_settings);
    $(window).on('resize', function() {
        if( $(window).width() <= 768) {
            if(!prevent_ways_slider.hasClass('slick-initialized')) {
                $('.prevent-ways').slick(prevent_ways_slider_settings);
            }
        } else {
            if (prevent_ways_slider.hasClass('slick-initialized')) {
                $('.prevent-ways').slick('unslick');
            }
        }
    });


    $('.play-pause-toggle').on('click',function (e) {
        e.preventDefault();
        let parent = $(this).closest('.wp-block-acf-our-partners');
        parent.toggleClass('paused');
    });



    gsap.registerPlugin(ScrollTrigger);

    // Get all .animate-panel elements except the last one
    let panels = gsap.utils.toArray(".animate-panel");
    var panelsToPin = panels.slice(0, -1); // exclude the last
    var pinnedTriggers = [];

    const createPanels = () => {
        pinnedTriggers = [];
        // Track start positions for snapping (optional)
        //tops = panelsToPin.map(panel => ScrollTrigger.create({trigger: panel, start: "top top"}));



        panelsToPin.forEach(panel => {
            let trigger = ScrollTrigger.create({
                trigger: panel,
                start: () => panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom",
                pin: true,
                pinSpacing: false,
                onEnter: () => {
                  if(!panel.classList.contains('has-primary-background-color')) return;
                  panel.classList.add("active");
                },
                onLeaveBack: () => {
                  panel.classList.remove("active");
                },
                onUpdate: self => {
                  let headerHeight = $('.header').height(),
                    windowHeight = $(window).height(),
                    percent = headerHeight / windowHeight;

                  if(!panel.classList.contains('has-primary-background-color')) return;

                  if (self.progress >= 1 - percent) {
                    panel.classList.remove("active");
                  } else {
                    panel.classList.add("active");
                  }
                }
            });

            pinnedTriggers.push(trigger);
        });
    }

    createPanels();

    $(document).on('click', '.open-video', function(e) {
        e.preventDefault();
        var postId = $(this).data('post-id'),
          provider = $(this).data('provider'),
          slot = $('.video-modal .video-modal-content');
        var preview;

        slot.empty();
        // Start from the :root 16/9 default; the branches below opt in to the
        // asset's real shape where it is knowable.
        applyAspectRatio(slot[0], '');

        if ( typeof provider !== 'undefined' && provider !== null ) {
          const src = $(this).data('src');

          if (provider === 'mp4') {
            const srcType = $(this).data('src-type');
            // Open at the poster's shape so portrait and square videos aren't
            // letterboxed into a landscape box; buildMp4Player corrects this
            // once the file reports its real dimensions.
            applyAspectRatio(slot[0], nearestAspectRatio(this));
            slot[0].appendChild(buildMp4Player(src, srcType));
          } else {
            // YouTube embeds are 16:9 regardless of the poster used to trigger
            // them, so leave the default in place.
            slot[0].appendChild(buildYouTubeIframe(src));
          }
          $('body').addClass('modal-is-opened');
          return;
        } else if( typeof postId !== 'undefined' ) {
          preview = $('.video-preview[data-post-id="'+postId+'"]');
        } else {
          preview = $(this).parent().find('.video-preview');
        }
        var video_code = preview.html();
        slot.html(video_code);
        $('body').addClass('modal-is-opened');
    });

    $(document).on('click', '.close-modal', function(e) {
        e.preventDefault();
        $('.video-modal .video-modal-content').html('');
        $('.video-modal .video-modal-content')[0].style.removeProperty('--ar');
        $('body').removeClass('modal-is-opened');
    });

    $(document).on('click', '.load-more', function(e) {
        e.preventDefault();
        $(this).closest('section').toggleClass('expanded');
    });

    var blocks = document.querySelectorAll('.accordion');
    blocks.forEach((block) => {
      block.addEventListener('tribe.accordion.open', (e) => {
        var $section = $(e.target).closest('.faq-section');
        calculateAnswerPosition($section);
      });
    });

    const calculateAnswerPosition = ( $section ) => {
      var $window = $(window),
        $scroll = $window.scrollTop(),
        $accordion = $section.find('.accordion'),
        $actualTop = $section.position().top + $accordion.position().top,
        $actualHeight = $accordion.height(),
        $answer = $accordion.find('.accordion-content.is-active'),
        $answerHeight = $answer.height();

      if( $window.width() < 780 ) {
        $answer.css('margin-top', 0);
        return;
      }

      if( $actualTop <= $scroll && $actualTop + $actualHeight > $scroll && $section.hasClass('expanded') ) {
          var $topSpacing = $scroll - $actualTop,
            $maxSpacing = ( $actualHeight - $answerHeight ) - 50;

          if( $topSpacing > 0 ) {
            if( $topSpacing <= $maxSpacing ) {
              $answer.css('margin-top', $topSpacing);
            } else {
              $answer.css('margin-top', $maxSpacing);
            }
          } else {
            $answer.css('margin-top', 0);
          }
        } else {
          $answer.css('margin-top', 0);
        }
    }

    $( window ).on( "scroll", function() {
      var $sections = $('.faq-section');
      
      $sections.each(function () {
        calculateAnswerPosition($(this));
      });
    });


    $( window ).on( "scroll", function() {

        // selectors
        var $window = $(window),
            $body = $('body'),
            $panel = $('.change-color'),
            foundpanel = false;

        var scroll = $window.scrollTop();

        $panel.each(function () {
            if( foundpanel ) return;
            var $this = $(this),
                $paddingTop = parseFloat($(this).css('padding-top')),
                $paddingBottom = parseFloat($(this).css('padding-bottom')),
                $actualTop = $this.position().top - $paddingTop,
                $actualHeight = $this.height() + $paddingTop + $paddingBottom;

            // if position is within range of this panel.
            // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
            // Remember we set the scroll to 33% earlier in scroll var.
            if ($this.hasClass('has-primary-background-color') && ( ( $actualTop <= scroll && $actualTop + $actualHeight > scroll && !$this.hasClass('animate-panel') ) || $this.hasClass('active') )) {

                // Remove all classes on body with color-
                $body.removeClass(function (index, css) {
                    return (css.match (/(^|\s)color-\S+/g) || []).join(' ');
                });

                // Add class of currently active div
                $body.addClass('secondary-menu-color');
                foundpanel = true;
            } else {
                $body.removeClass('secondary-menu-color');
            }
        });

    });

    const checkExpandableBlocks = () => {

      $('.resources').each(function() {
        $(this).removeClass('expandable');

        let block = $(this).find('.resources-block'),
          blockInner = $(this).find('.inner'),
          featuredInner = block.find('.resources__featured-inner'),
          fadeHeight = 200;
        
        blockInner.css( 'max-height', 'auto' );

        if( window.innerWidth <= 768 ) {
          fadeHeight = featuredInner.height();
        }

        if( block.height() > featuredInner.height() + fadeHeight ) {
          $(this).addClass( 'expandable' );
          blockInner.css( 'max-height', featuredInner.height() + fadeHeight );
        }
      });
    }

    checkExpandableBlocks();
});

// Refresh after load (images), after fonts, and when returning from bfcache
window.addEventListener('load', () => {
  requestAnimationFrame(() => safeRefresh());
});

document.fonts?.ready.then(() => {
  // webfonts can change metrics after DOMContentLoaded
  safeRefresh();
});

window.addEventListener('pageshow', (e) => {
  if (e.persisted) safeRefresh();  // Safari/Firefox back-forward cache
});

function safeRefresh({ rebuild = false } = {}) {
  const y = window.scrollY;
  const html = document.documentElement;

  // prevent janky animated scroll during the jump-to-top
  const prevScrollBehavior = html.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';

  // go to top so pin-spacer math is correct
  window.scrollTo(0, 0);

  // optional: rebuild triggers if your layout/DOM changed
  if (rebuild) {
    ScrollTrigger.getAll().forEach(st => st.kill());
    buildPins(); // <-- define this (see section 2)
  }

  // do the real refresh now that we're at the top
  ScrollTrigger.refresh();

  // restore previous scroll position on the next frame
  requestAnimationFrame(() => {
    window.scrollTo(0, y);
    html.style.scrollBehavior = prevScrollBehavior || '';
  });
}


////////////////////////////////
// SHARE MODAL START
////////////////////////////////

const hasST = !!window.ScrollTrigger;
  if (window.gsap && hasST) gsap.registerPlugin(ScrollTrigger);

const modal         = document.getElementById('shareModal');
  const dialog        = modal.querySelector('.asset-modal__dialog');
  const imgEl         = modal.querySelector('#modalImage');
  const titleEl       = modal.querySelector('#modalTitle');
  const captionEl     = modal.querySelector('#modalCaption');
  const closeBtn      = modal.querySelector('.asset-modal__close');

  let lastFocusedEl   = null;
  let scrollYBefore   = 0;

  const getScrollbarWidth = () =>
    window.innerWidth - document.documentElement.clientWidth;

    function disableScrollAndST() {
    // freeze ScrollTrigger without reverting pin styles
    if (hasST) ScrollTrigger.getAll().forEach(st => st.disable(false));

    scrollYBefore = window.scrollY;
    const sbw = getScrollbarWidth();
    document.documentElement.style.setProperty('--sbw', sbw + 'px');
    document.documentElement.classList.add('modal-open');
    document.body.classList.add('modal-open');
  }

  function enableScrollAndST() {
    document.body.classList.remove('modal-open');
    document.documentElement.classList.remove('modal-open');
    document.documentElement.style.removeProperty('--sbw');

    window.scrollTo(0, scrollYBefore);

    // re-enable and refresh measurements
    if (hasST) {
      ScrollTrigger.getAll().forEach(st => st.enable(false));
      requestAnimationFrame(() => ScrollTrigger.refresh());
    }
  }

function openModal({ src, title, caption, alt, permalink, postId, hasVideo, provider, dataSrc, srcType }) {
    lastFocusedEl = document.activeElement;

    // Populate
    titleEl.textContent   = title || '';
    captionEl.textContent = caption || '';
    imgEl.alt             = alt || title || caption || '';

    // Clear previous image first to avoid flicker
    imgEl.removeAttribute('src');

    //disableScrollAndST();

    const text = title || document.title;

    // Compose platform share links
    const shareFB = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(permalink)}`;
    const shareX  = `https://x.com/intent/post?text=${encodeURIComponent(text)}&url=${encodeURIComponent(permalink)}`;
    const shareLI = `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(text) + ' ' + encodeURIComponent(permalink)}`;

    // Populate anchors (if present)
    const aFB = document.getElementById('shareFB');
    const aX  = document.getElementById('shareX');
    const aLI = document.getElementById('shareLI');
    if (aFB) aFB.href = shareFB;
    if (aX)  aX.href  = shareX;
    if (aLI) aLI.href = shareLI;

    modal.classList.add('is-open');
    requestAnimationFrame(() => {
      modal.classList.add('show');
      // load new image after visible to feel snappy
      imgEl.src = src;

      if (imgEl.complete) {
        // cached images may already be complete
        fitModalToImage();
      } else {
        imgEl.addEventListener('load', fitModalToImage, { once: true });
      }

      // focus close for a11y
      closeBtn.focus({ preventScroll: true });
    });
  }

  function closeModal() {
    modal.classList.remove('show');
    modal.addEventListener('transitionend', (e) => {
      if (e.propertyName !== 'opacity') return;
      modal.classList.remove('is-open');

      // restore focus
      if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
        lastFocusedEl.focus({ preventScroll: true });
      }

      //enableScrollAndST();
    }, { once: true });
  }

  // Click handler (event delegation)
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('.js-asset-modal');
    if (!trigger) return;

    if (!GALLERY.length) buildGallery();

    const idx = GALLERY.findIndex(item => item.permalink === trigger.getAttribute('href'));
    const firstIndex = idx >= 0 ? idx : 0;

    const payload = GALLERY[firstIndex];
    renderModal(payload);

    // Left-click or keyboard activation only
    if (e.button === 0 || e.type === 'keydown' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      // Let cmd/ctrl-click open the real page in new tab
      if (e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      openModalWithHistory(payload);
    }

    currentIndex = firstIndex;
    updateNavDisabled();
  });

  // Close interactions
  closeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    closeModalWithHistory();
  });
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModalWithHistory();
  });
  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closeModalWithHistory();
    } else if (e.key === 'Tab') {
      // simple focus trap
      const focusables = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const list = Array.from(focusables).filter(el => !el.hasAttribute('disabled'));
      if (!list.length) return;

      const first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  });

window.addEventListener('popstate', (e) => {
  const modal   = document.getElementById('shareModal');
  const state   = e.state;

  if (state && state.type === 'modal') {
    // Open or update to the requested item
    if (!modal.classList.contains('is-open')) {
      if (typeof openModal === 'function') openModal(state.payload);
      modal.classList.add('is-open', 'show');
    }
    // Sync gallery/index (find by permalink if needed)
    if (!GALLERY.length) buildGallery();
    currentIndex = (typeof state.index === 'number')
      ? state.index
      : Math.max(0, GALLERY.findIndex(i => i.permalink === state.payload.permalink));
    renderModal(GALLERY[currentIndex] || state.payload);
    updateNavDisabled();
  } else {
    // Any non-modal history → close modal
    if (modal?.classList.contains('is-open')) {
      if (typeof closeModal === 'function') closeModal();
      else modal.classList.remove('is-open', 'show');
      currentIndex = -1;
    }
  }
});

  let GALLERY = [];
let currentIndex = -1;
const WRAP_AROUND = false; 

  // Build payload from a thumbnail anchor
  function payloadFromTrigger(trigger) {
    const img = trigger.querySelector('img');
    const src = trigger.dataset.image || trigger.getAttribute('href') || img?.src;
    const title = trigger.getAttribute('title') || trigger.dataset.title || img?.alt || '';
    let caption = trigger.dataset.caption || '';
    if (!caption) {
      const fig = trigger.closest('figure');
      caption = fig?.querySelector('figcaption')?.textContent?.trim() || '';
    }
    const alt = img?.alt || title || caption || '';
    const permalink = trigger.href;
    const postId = trigger.dataset.postId || null;
    const hasVideo = trigger.dataset.isVideo || false;
    const provider = trigger.dataset.provider || null;
    const dataSrc = trigger.dataset.src || null;
    const srcType = trigger.dataset.srcType || null;
    return { src, title, caption, alt, permalink, postId, hasVideo, provider, dataSrc, srcType  };
  }

  // Open modal and push state to the permalink
  function openModalWithHistory(payload) {
    // Push the permalink into the URL bar
    history.pushState({ type: 'modal', payload }, '', payload.permalink);
    // Open the UI
    openModal(payload);
  }

  // Close via history so Back button works naturally
  function closeModalWithHistory() {
    // If we're currently in a modal state, go back one step; otherwise just close.
      closeModal(); // fallback
      // Ensure URL is the root (optional)
      history.pushState({}, '', ROOT_URL);
  }

  // Call after <img> has its src set (and on resize).
function fitModalToImage() {
  const dialog  = document.querySelector('#shareModal .asset-modal__dialog');
  const content = dialog.querySelector('.asset-modal__content');
  const img     = dialog.querySelector('#modalImage');

  if (!dialog || !content || !img) return;
  const natW = img.naturalWidth || img.width;
  const natH = img.naturalHeight || img.height;
  if (!natW || !natH) return; // not loaded yet

  // Read spacing from CSS (keeps JS + CSS in sync)
  const cs   = getComputedStyle(content);
  const gap  = parseFloat(cs.getPropertyValue('--gap')) || 24;
  const pad  = parseFloat(cs.getPropertyValue('--pad')) || 28;

  const maxDialogW = Math.floor(window.innerWidth * 0.96); // 96vw
  const maxDialogH = Math.floor(window.innerHeight * 0.90); // 90vh

  // Max column width allowed by viewport width: (dialogW - padding*2 - gap)/2
  const colMaxFromVW = Math.floor((maxDialogW - pad * 2 - gap) / 2);

  // Max column width allowed by viewport height (convert height limit → width using aspect ratio)
  const colMaxFromVH = Math.floor((maxDialogH - pad * 2) * (natW / natH));

  // Final column width: can't exceed natural image width, vw, or vh constraint
  const colW = Math.max(
    160, // a small sanity minimum so text doesn't collapse
    Math.min(natW, colMaxFromVW, colMaxFromVH)
  );

  const dialogW = Math.floor(colW * 2 + gap + pad * 2);

  // Apply width, but still respect CSS max-width
  dialog.style.width = dialogW + 'px';
}

// Re-run on resize (debounced)
let _tm;
window.addEventListener('resize', () => {
  clearTimeout(_tm);
  _tm = setTimeout(() => fitModalToImage(), 120);
});

const modalPreviousBtn      = modal.querySelector('.asset-modal__navigation button.previous');
const modalNextBtn      = modal.querySelector('.asset-modal__navigation button.next');

modalPreviousBtn.addEventListener('click', (e) => {
    e.preventDefault();
    navigate(-1);
  });

  modalNextBtn.addEventListener('click', (e) => {
    e.preventDefault();
    navigate(1);
  });

function buildGallery() {
  const nodes = Array.from(document.querySelectorAll('.js-asset-modal'));
  GALLERY = nodes.map(payloadFromTrigger);
}

function updateNavDisabled() {
  const prev = document.querySelector('#shareModal button.previous');
  const next = document.querySelector('#shareModal button.next');
  if (!prev || !next) return;
  if (WRAP_AROUND) {
    prev.disabled = false; next.disabled = false;
  } else {
    prev.disabled = (currentIndex <= 0);
    next.disabled = (currentIndex >= GALLERY.length - 1);
  }
}

function renderModal(payload) {
  const modal   = document.getElementById('shareModal');
  const titleEl = modal.querySelector('#modalTitle');
  const capEl   = modal.querySelector('#modalCaption');
  const imgEl   = modal.querySelector('#modalImage');

  jQuery('#shareModal').find('a.open-video').data('post-id', payload.postId);
  jQuery('#shareModal').find('a.open-video').data('src', payload.dataSrc);
  jQuery('#shareModal').find('a.open-video').data('src-type', payload.srcType);
  jQuery('#shareModal').find('a.open-video').data('provider', payload.provider);

  if( payload.hasVideo ) {
    modal.classList.add('has-video');
  } else {
    modal.classList.remove('has-video');
  }
  titleEl.textContent = payload.title || '';
  capEl.textContent   = payload.caption || '';

  // Update share links if you wired setShareLinks earlier
  if (typeof setShareLinks === 'function') {
    setShareLinks({ permalink: payload.permalink, title: payload.title });
  }

  // Swap image (preserve a11y)
  imgEl.alt = payload.alt || payload.title || payload.caption || '';
  const newSrc = payload.src;

  if (imgEl.src === newSrc) {
    // already shown
    if (typeof fitModalToImage === 'function') fitModalToImage();
  } else {
    // load then size
    imgEl.addEventListener('load', () => {
      if (typeof fitModalToImage === 'function') fitModalToImage();
    }, { once: true });
    imgEl.src = newSrc;
  }
}

function showByIndex(index, { historyMode = 'push' } = {}) {
  if (!GALLERY.length) buildGallery();
  const len = GALLERY.length;
  if (!len) return;

  let idx = index;
  if (WRAP_AROUND) {
    idx = (idx + len) % len;
  } else {
    idx = Math.max(0, Math.min(len - 1, idx));
  }

  currentIndex = idx;
  const payload = GALLERY[currentIndex];

  // Update URL + state so Back/Forward works across items
  const state = { type: 'modal', payload, index: currentIndex };
  if (historyMode === 'replace') {
    history.replaceState(state, '', payload.permalink);
  } else {
    history.pushState(state, '', payload.permalink);
  }

  renderModal(payload);
  updateNavDisabled();
}

function navigate(delta) {
  if (currentIndex < 0) return;
  showByIndex(currentIndex + delta, { historyMode: 'push' });
}

document.addEventListener('keydown', (e) => {
  const modalOpen = document.getElementById('shareModal')?.classList.contains('is-open');
  if (!modalOpen) return;
  if (e.key === 'ArrowLeft')  { e.preventDefault(); navigate(-1); }
  if (e.key === 'ArrowRight') { e.preventDefault(); navigate(1); }
});

  // Optional: deep-link support (land on the grid while URL is already a post permalink)
  // If the current URL matches one of our thumbs’ permalinks, open that modal on load.
  window.addEventListener('DOMContentLoaded', () => {
    const currentPath = new URL(location.href).pathname;
    if (!GALLERY.length) buildGallery();

    const idx = GALLERY.findIndex(item => new URL(item.permalink, location.origin).pathname === currentPath);

    if( idx < 0 ) return;

    const payload = GALLERY[idx];
    renderModal(payload);

    openModalWithHistory(payload);

    currentIndex = idx;
    updateNavDisabled();
  });



  // Write an aspect ratio onto an element as the --ar custom property consumed by
  // .video-modal-content in src/scss/global/_modal.scss. A falsy ratio removes the
  // override so the :root default (16/9) applies again.
  function applyAspectRatio(el, ratio) {
    if (!el) return;
    if (ratio) el.style.setProperty('--ar', ratio);
    else el.style.removeProperty('--ar');
  }

  // Best ratio known at click time, taken from the poster inside the trigger
  // (#modalImage in the asset modal, the placeholder image in the media slider).
  // Returns '' when nothing is known, leaving the :root 16/9 default in place.
  function nearestAspectRatio(trigger) {
    const img = trigger.querySelector && trigger.querySelector('img');
    if (img && img.naturalWidth && img.naturalHeight) {
      return img.naturalWidth + ' / ' + img.naturalHeight;
    }
    return '';
  }

  function buildMp4Player(src, srcType) {
    const v = document.createElement('video');
    v.src = src;
    if (srcType) v.type = srcType;
    // The poster and the video can differ; correct the box once the real
    // dimensions are known.
    v.addEventListener('loadedmetadata', () => {
      if (v.videoWidth && v.videoHeight) {
        applyAspectRatio(v.parentElement, v.videoWidth + ' / ' + v.videoHeight);
      }
    }, { once: true });
    v.controls = true;
    v.autoplay = true;       // try to autoplay immediately after user click
    v.muted = false;         // set true if you need guaranteed autoplay without user gesture
    v.playsInline = true;    // iOS inline playback
    v.setAttribute('preload', 'metadata');
    return v;
  }

  function buildYouTubeIframe(id) {
    const iframe = document.createElement('iframe');
    // Use youtube-nocookie if you prefer
    iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=0&playsinline=1&rel=0`;
    iframe.title = 'YouTube video player';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    return iframe;
  }